<script>
import Layout from "@/router/layouts/main";
import Breadcrumb from "@/components/Breadcrumb";
import AccountTabs from "@/components/AccountTabs";
import { api } from "@/state/services";
import { mapState } from "vuex";
import { required, minLength } from "vuelidate/lib/validators";

// Valida telefone opcional (vazio ou com 10/11 dígitos)
const phoneOptional = (value) => {
  const digits = String(value || "").replace(/\D/g, "");
  return digits.length === 0 || digits.length === 10 || digits.length === 11;
};

// Escolhe a máscara conforme a quantidade de dígitos (fixo ou celular)
const phoneMask = (value) => {
  const digits = String(value || "").replace(/\D/g, "");
  return digits.length > 10 ? "(##) #####-####" : "(##) ####-#####";
};

export default {
  components: {
    Layout,
    Breadcrumb,
    AccountTabs
  },
  data() {
    return {
      loading: false,
      form: {
        phone: "",
        cellphone: "",
      },
    };
  },
  validations: {
    form: {
      phone: { phoneOptional },
      cellphone: { required, minLength: minLength(14) },
    },
  },
  computed: {
    ...mapState({
      account: (state) => state.account,
    }),
    emailValidated() {
      const status = String(this.account.user.email ? this.account.user.email.status : "").toLowerCase();
      return ["validated", "confirmed", "approved", "verified", "1"].includes(status);
    },
    phoneMask() {
      return phoneMask(this.form.phone);
    },
    cellphoneMask() {
      return phoneMask(this.form.cellphone);
    },
  },
  methods: {
    fillForm() {
      this.form.phone = this.account.user.phone || "";
      this.form.cellphone = this.account.user.cellphone || "";
    },
    submit() {
      this.$v.form.$touch();
      if (this.$v.form.$invalid) {
        return;
      }

      this.loading = true;
      api
        .put("user", {
          section: "contacts",
          phone: this.form.phone,
          cellphone: this.form.cellphone,
        })
        .then((response) => {
          if (response.data.status == "success") {
            // Atualiza o usuário da sessão com os novos contatos
            this.$store.state.account.user = Object.assign({}, this.account.user, {
              phone: response.data.user.phone,
              cellphone: response.data.user.cellphone,
            });
            this.$v.form.$reset();
            this.$toast.success(response.data.message);
          } else {
            this.$toast.error(response.data.message || "Não foi possível salvar, tente novamente.");
          }
        })
        .catch(() => {
          this.$toast.error("Não foi possível salvar, tente novamente.");
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  mounted() {
    this.fillForm();
  },
};
</script>

<template>
  <Layout>
    <Breadcrumb :items="[{ text: 'Minha Conta' }, { text: 'Contatos' }]" />
    <AccountTabs></AccountTabs>
    <div class="row">
      <div class="col-xl-7">
        <div class="card">
          <div class="card-body">
            <b-form class="p-3" @submit.prevent="submit">
              <b-form-group label="E-mail" label-for="email">
                <div class="d-flex align-items-center">
                  <b-form-input id="email" :value="account.user.email ? account.user.email.address : ''" type="text" readonly class="notranslate"></b-form-input>
                  <span v-if="emailValidated" class="badge badge-success ml-2">Validado</span>
                  <span v-else class="badge badge-warning ml-2">Não validado</span>
                </div>
                <small class="text-muted">Para trocar o e-mail, fale com a nossa equipe.</small>
              </b-form-group>
              <b-form-group label="Telefone" label-for="phone">
                <b-form-input id="phone" v-model="form.phone" type="tel" autocomplete="off" v-mask="phoneMask" :class="{ 'is-invalid': $v.form.phone.$error }"></b-form-input>
                <div v-if="$v.form.phone.$error" class="invalid-feedback">Informe um telefone válido.</div>
              </b-form-group>
              <b-form-group label="Celular/WhatsApp" label-for="cellphone">
                <b-form-input id="cellphone" v-model="form.cellphone" type="tel" autocomplete="off" v-mask="cellphoneMask" :class="{ 'is-invalid': $v.form.cellphone.$error }"></b-form-input>
                <div v-if="$v.form.cellphone.$error" class="invalid-feedback">Informe um celular válido.</div>
              </b-form-group>
              <div class="mt-4">
                <b-button :disabled="loading" type="submit" variant="default">
                  Salvar
                  <b-spinner v-if="loading" small class="ml-2 align-middle" variant="white" role="status"></b-spinner>
                </b-button>
              </div>
            </b-form>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
